import 'phaser';
import { CST } from '../CST';
import card from '../model/card.js';
import config from '../helpers/config.js';
import { language } from './language';
import { Controller } from '../controller/controller.js';
import $ from 'jquery';
import BoardViewOnly from './boardViewOnly';

let clickSound;
let time_left;
let time_timer;
let timer;
let duration;
let started;
let count;
let cardCounter = 0;
let end;
let timerBox;
let first;
let first2;
let timerStarted = false;

export default class Board extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.BOARD);
	}

	init() {
		this.self = self;
		started = false;
		count = 0;
		end = false;
		first = true;
		first2 = true;
	}

	async preload() {
		this.timer;
		this.id = 1;

		this.load.image('bg', 'assets/english/bg.png');
		this.load.image('clock', 'assets/english/clock.png');
		this.load.image('overlay', 'assets/english/overlay.png');
		this.load.image('black_bg', 'assets/english/black_screen.png');
		this.load.image('backCardScenario', 'assets/english/scenario-card-back.png');
		this.load.image('backCardFeedback', 'assets/english/feedback-card-back.png');
		this.load.image('rules_btn', 'assets/english/rules-game.png');
		this.load.image('home_btn', 'assets/english/home.png');
		this.load.image('end_game_btn', 'assets/english/end-game.png');
		this.load.image('show-feedback-btn', 'assets/english/show-feedback-btn.png');
		this.load.image('next_btn', 'assets/english/go-forward.png');
		this.load.image('appreciate_btn', 'assets/english/appreciate.png');
		this.load.image('appreciate-small_btn', 'assets/english/appreciate-small.png');
		this.load.image('close_btn', 'assets/english/close.png');
		this.load.image('5minLeft', 'assets/english/5minLeft.png');
		this.load.image('2minLeft', 'assets/english/2minLeft.png');
		this.load.image('game_over', 'assets/english/game_over.png');
		this.load.image('times_up', 'assets/english/times-up.png');
		this.load.image('popup-facilitator-tab', 'assets/popup-facilitator-tab.png');
		this.load.spritesheet({
			key: 'cardFlipScenario',
			url: 'assets/card-flip-scenario.png',
			frameConfig: { frameWidth: 758.68, frameHeight: 794 },
		});
		this.load.spritesheet({
			key: 'cardFlipFeedback',
			url: 'assets/card-flip-feedback.png',
			frameConfig: { frameWidth: 758.68, frameHeight: 794 },
		});
		this.load.spritesheet({
			key: 'roulette-sprite',
			url: 'assets/english/roulette.png',
			frameConfig: { frameWidth: 751.67, frameHeight: 813 },
		});
		this.load.spritesheet({
			key: '2min-sprite',
			url: 'assets/english/2min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: '5min-sprite',
			url: 'assets/english/5min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: '7min-sprite',
			url: 'assets/english/7min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: '10min-sprite',
			url: 'assets/english/10min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: 'firework-blue',
			url: 'assets/firework-blue.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		this.load.spritesheet({
			key: 'firework-red',
			url: 'assets/firework-red.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		this.load.spritesheet({
			key: 'firework-yellow',
			url: 'assets/firework-yellow.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		for (let i = 1; i <= 28; i++) {
			this.load.image('scenario' + i, 'assets/english/cards/scenario (' + i + ').png');
			this.load.image(
				'zoom-scenario' + i,
				'assets/english/cards/eng-expanded/cardZoom-scenario (' + i + ').png',
			);
			this.load.image('feedback' + i, 'assets/english/cards/feedback (' + i + ').png');
			this.load.image(
				'zoom-feedback' + i,
				'assets/english/cards/eng-expanded/cardZoom-feedback (' + i + ').png',
			);
		}
	}

	create(data) {
		this._sceneData = data;
		this.chatChannel = new BroadcastChannel('chat_channel');
		// window.open('http://localhost:5173/?view=10', '_blank'); //Local
		// window.open('https://dev-html.focusgames.com/leadership_roulette/?view=10', '_blank'); //Dev
		// window.open('https://test-html.focusgames.com/leadership_roulette/?view=10', '_blank'); //Test
		window.open('https://play.leadershiproulette.co.uk/?view=10', '_blank'); //Live

		this.showFacilitatorPopup();

		if (config.online) {
			$.ajax({
				type: 'POST',
				url: 'website/post-log.php',
				data: { device: navigator.userAgent },
			});
		}

		clickSound = this.sound.add('clickSound');

		this.anims.create({
			key: 'flip',
			frames: this.anims.generateFrameNames('cardFlipScenario'),
			frameRate: 60,
			repeat: 0,
		});

		this.anims.create({
			key: 'flip2',
			frames: this.anims.generateFrameNames('cardFlipFeedback'),
			frameRate: 60,
			repeat: 0,
		});

		this.anims.create({
			key: 'roulette-spin',
			frames: this.anims.generateFrameNumbers('roulette-sprite'),
			frameRate: 15,
			repeat: -1,
		});

		this.controller = new Controller(this);
		this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg' + language)
			.setScale(1);

		this.deck = [];
		this.deck2 = [];

		if (data && data.categories) {
			this.deck.push(...data.categories);
			this.deck2.push(...data.categories);
		}

		[this.deck, this.deck2] = this.shuffleDecks(this.deck, this.deck2);

		timerBox = this.add.image(this.cameras.main.width / 2, 48, 'clock');

		this.rules = this.add
			.image(1395, 50, 'rules_btn' + language)
			.setScale(1.2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				(clickSound.play(),
					this.scene.pause(),
					this.scene.launch(CST.SCENES.RULES1, { scene: CST.SCENES.BOARD }));
				this.chatChannel.postMessage(JSON.stringify({ action: 'rules' }));
			});

		this.back = this.add
			.image(1200, 50, 'home_btn' + language)
			.setScale(0.75)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.start(CST.SCENES.MENU, { scene: CST.SCENES.BOARD });
			});

		this.btn2min = this.add
			.sprite(
				this.cameras.main.width / 2 - 410,
				this.cameras.main.height / 2 + 420,
				'2min-sprite',
				0,
			)
			.setVisible(false)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.assignTimeToCategory(120);
			});

		this.btn5min = this.add
			.sprite(
				this.cameras.main.width / 2 - 310,
				this.cameras.main.height / 2 + 420,
				'5min-sprite',
				0,
			)
			.setVisible(false)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.assignTimeToCategory(300);
			});

		this.btn7min = this.add
			.sprite(
				this.cameras.main.width / 2 - 210,
				this.cameras.main.height / 2 + 420,
				'7min-sprite',
				0,
			)
			.setVisible(false)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.assignTimeToCategory(420);
			});

		this.btn10min = this.add
			.sprite(
				this.cameras.main.width / 2 - 110,
				this.cameras.main.height / 2 + 420,
				'10min-sprite',
				0,
			)
			.setVisible(false)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.assignTimeToCategory(600);
			});

		this.endgameBtn = this.add
			.image(
				this.cameras.main.width / 2 + 600,
				this.cameras.main.height / 2 + 420,
				'end_game_btn' + language,
			)
			.setScale(1.1)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				this.endGame();
			});

		this.backCard = this.add
			.sprite(
				this.cameras.main.width / 2 - 370,
				this.cameras.main.height / 2,
				'backCardScenario' + language,
			)
			.setInteractive({ useHandCursor: true })
			.on(
				'pointerdown',
				() => {
					clickSound.play();
					this.cardFlip();
					// if (count === this.cardDeck.length) {
					//   this.backCard.destroy();
					// }
					this.btn2min.setVisible(true);
					this.btn5min.setVisible(true);
					this.btn7min.setVisible(true);
					this.btn10min.setVisible(true);
					this.backCard.disableInteractive();
				},
				this,
			);

		this.backCard2 = this.add
			.sprite(
				this.cameras.main.width / 2 + 370,
				this.cameras.main.height / 2,
				'backCardFeedback' + language,
			)
			.on(
				'pointerdown',
				() => {
					clickSound.play();
					this.cardFlip2();

					this.backCard2.disableInteractive();
					// if (count === this.cardDeck.length) {
					//   this.backCard2.destroy();
					// }
				},
				this,
			)
			.disableInteractive();

		this.btnShowFeedbackClient = this.add
			.image(
				this.cameras.main.width / 2 + 260,
				this.cameras.main.height / 2 + 420,
				'show-feedback-btn' + language,
			)
			.setScale(1)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.btnShowFeedbackClient.setVisible(false);

				const cardData = {
					action: 'card-flip2',
					key: this.nextFeedback,
				};
				this.card2.setInteractive();
				this.nextScenario.setInteractive().setVisible(true);
				this.chatChannel.postMessage(JSON.stringify(cardData));
			})
			.setVisible(false);

		this.nextScenario = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 420, 'next_btn' + language)
			.setScale(1.25)
			.setDepth(1)
			.setVisible(false)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.resetTimer();
				count++;
				this.chatChannel.postMessage(JSON.stringify({ action: 'next-cs' }));
				this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0, 0).setScale(2).setDepth(1);

				this.roulette = this.add
					.sprite(this.cameras.main.width / 2, this.cameras.main.height / 2, 'roulette-sprite')
					.setDepth(2)
					.play('roulette-spin');

				this.time.delayedCall(4000, () => {
					this.roulette.destroy();
					this.overlay.destroy();
					this.card.destroy();
					this.card2.destroy();
					started = false;
					timerStarted = false;
					first = true;
					first2 = true;
					this.backCard.active = true;
					this.backCard.setInteractive();
					this.backCard2.disableInteractive();
					this.nextScenario.setVisible(false);
					if (this.deck.length > 0) {
						this.deck.shift();
					}
					if (this.deck2.length > 0) {
						this.deck2.shift();
					}
					this.checkDecks();
				});
			});

		this.fireworkBtn = this.add
			.image(150, this.cameras.main.height / 2 + 420, 'appreciate_btn' + language)
			.setScale(1.1)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.startFireworks();
				this.chatChannel.postMessage(JSON.stringify({ action: 'fireworks' }));
			});

		// if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
		//   this.fireworkBtn.x = this.cameras.main.width / 2 - 610;
		// }

		this.fiveMinPopup = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, '5minLeft' + language)
			.setDepth(2.2)
			.setVisible(false);
		this.twoMinPopup = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, '2minLeft' + language)
			.setDepth(2.2)
			.setVisible(false);

		if (data.board === CST.SCENES.ENDSCREEN) {
			this.scene.remove(CST.SCENES.ENDSCREEN);
			this.scene.add(CST.SCENES.ENDSCREEN, EndScreen, false);
		}
	}

	endGame() {
		if (end === true) {
			clickSound.play();
			this.scene.start(CST.SCENES.ENDSCREEN, {
				scene: CST.SCENES.BOARD,
				data: this._sceneData?.data,
			});
		} else {
			end = true;
			clickSound.play();
			if (first === false) this.card.disableInteractive();
			if (first2 === false) this.card2.disableInteractive();
			this.back.disableInteractive();
			if (this.backCard.active) this.backCard.disableInteractive();
			if (this.backCard2.active) this.backCard2.disableInteractive();
			this.rules.disableInteractive();
			// this.fireworkBtn.disableInteractive();
			this.endgameBtn.disableInteractive();
			this.add.image(
				this.cameras.main.width / 2,
				this.cameras.main.height / 2,
				'game_over' + language,
			);
			this.chatChannel.postMessage(JSON.stringify({ action: 'end-game' }));
			setTimeout(() => {
				this.scene.start(CST.SCENES.ENDSCREEN, {
					scene: CST.SCENES.BOARD,
					data: this._sceneData?.data,
				});
			}, 2500);
		}
	}

	checkDecks() {
		if (this.deck.length === 0 || this.deck2.length === 0) {
			this.endGame();
		}
	}

	assignTimeToCategory(duration) {
		switch (duration) {
			case 120:
				timer = this.add
					.text(this.cameras.main.width / 2 - 5, 37, '2:00', CST.TEXTSTYLES.TIMERSTYLE)
					.setDepth(2);
				break;
			case 300:
				timer = this.add
					.text(this.cameras.main.width / 2 - 5, 37, '5:00', CST.TEXTSTYLES.TIMERSTYLE)
					.setDepth(2);
				break;
			case 420:
				timer = this.add
					.text(this.cameras.main.width / 2 - 5, 37, '7:00', CST.TEXTSTYLES.TIMERSTYLE)
					.setDepth(2);
				break;
			case 600:
				timer = this.add
					.text(this.cameras.main.width / 2 - 5, 37, '10:00', CST.TEXTSTYLES.TIMERSTYLE)
					.setDepth(2);
				break;
		}

		this.chatChannel.postMessage(JSON.stringify({ action: 'timer', time: duration }));
		this.backCard2.active = true;
		this.backCard2.setInteractive({ useHandCursor: true });
		time_left = duration;
		time_timer = this.scene.scene.time.now;
		this.btn2min.setVisible(false);
		this.btn5min.setVisible(false);
		this.btn7min.setVisible(false);
		this.btn10min.setVisible(false);
		this.card.setInteractive();
		started = true;
		timerStarted = true;
		this.chatChannel.postMessage(JSON.stringify({ action: 'start-timer' }));
	}

	cardFlip() {
		if (this.backCard.active) this.backCard.disableInteractive();
		if (count >= this.deck.length) {
			count = 0;
		}

		var num = this.deck[count];
		var key = 'scenario' + num.toString();
		var zoomKey = 'zoom-scenario' + num.toString();

		if (first) {
			first = false;
			this.card = this.add
				.image(this.backCard.x, this.cameras.main.height / 2)
				.setInteractive({ useHandCursor: true })
				.on('pointerdown', () => {
					this.cardZoom(zoomKey);
					this.chatChannel.postMessage(JSON.stringify({ action: 'card-zoom', key, zoomKey }));
				})
				.disableInteractive();
		}

		const cardAnim = this.add
			.sprite(this.backCard.x, this.cameras.main.height / 2, 'backCard' + language)
			.play('flip');

		cardAnim.on('animationcomplete', () => {
			// if (count !== this.cardDeck.length) this.backCard.setInteractive();
			this.card.setTexture(key);
			this.card.off('pointerdown');
			this.card.on('pointerdown', () => {
				this.cardZoom(zoomKey);
				this.chatChannel.postMessage(JSON.stringify({ action: 'card-zoom', key, zoomKey }));
			});
			cardAnim.destroy();
		});

		const cardData = {
			action: 'card-flip',
			key,
		};

		this.chatChannel.postMessage(JSON.stringify(cardData));
	}

	cardFlip2() {
		this.btnShowFeedbackClient.setVisible(true);
		this.backCard2.active = false;

		if (count >= this.deck.length) {
			count = 0;
		}

		var num = this.deck2[count];
		var key = 'feedback' + num.toString();
		var zoomKey = 'zoom-feedback' + num.toString();

		if (first2) {
			first2 = false;
			this.card2 = this.add
				.image(this.backCard2.x, this.cameras.main.height / 2)
				.setInteractive({ useHandCursor: true })
				.on('pointerdown', () => {
					this.cardZoom2(zoomKey);
					this.chatChannel.postMessage(JSON.stringify({ action: 'card-zoom', key, zoomKey }));
				});
		}

		const cardAnim2 = this.add
			.sprite(this.backCard2.x, this.cameras.main.height / 2, 'backCard' + language)
			.play('flip2');

		cardAnim2.on('animationcomplete', () => {
			// if (count !== this.cardDeck.length) this.backCard2.setInteractive();
			this.card2.setTexture(key);
			this.card2.off('pointerdown');
			this.card2
				.on('pointerdown', () => {
					this.cardZoom2(zoomKey);
					this.chatChannel.postMessage(JSON.stringify({ action: 'card-zoom', key, zoomKey }));
				})
				.disableInteractive();
			cardAnim2.destroy();

			this.nextFeedback = key;
		});
	}

	cardZoom(zoomKey) {
		if (this.backCard.active) this.backCard.disableInteractive();
		if (this.backCard2.active) this.backCard2.disableInteractive();
		this.card.disableInteractive();
		if (!first2) this.card2.disableInteractive();
		// if (!first && !first2) this.nextScenario.disableInteractive();
		this.rules.disableInteractive();
		this.back.disableInteractive();
		this.endgameBtn.disableInteractive();
		this.fireworkBtn.disableInteractive();

		this.timerBox2 = this.add
			.image(this.cameras.main.width / 2 - 650, this.cameras.main.height / 2 + 400, 'clock')
			.setDepth(1);

		timer.x = this.cameras.main.width / 2 - 650;
		timer.y = this.cameras.main.height / 2 + 389;

		this.blackBg = this.add
			.image(0, 0, 'black_bg')
			.setOrigin(0, 0)
			.setScale(2)
			.setAlpha(0.8)
			.setDepth(0.9);

		this.zoomCard = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 15, zoomKey + language)
			.setDepth(2)
			.setScale(1);

		this.zoomedFireworkBtn = this.add
			.image(this.cameras.main.width / 2 + 630, 50, 'appreciate-small_btn' + language)
			.setScale(1.25)
			.setDepth(2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				this.startFireworks();
				this.chatChannel.postMessage(JSON.stringify({ action: 'fireworks' }));
			});

		this.closeBtn = this.add
			.image(110, 50, 'close_btn' + language)
			.setScale(1.2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				timer.x = this.cameras.main.width / 2 - 5;
				timer.y = 37;

				this.zoomedFireworkBtn.destroy();
				this.blackBg.destroy();
				this.zoomCard.destroy();
				this.closeBtn.destroy();
				this.timerBox2.destroy();
				this.card.setInteractive();
				// if (this.backCard.active) this.backCard.setInteractive();
				this.rules.setInteractive();
				this.back.setInteractive();
				this.endgameBtn.setInteractive();
				this.fireworkBtn.setInteractive();

				if (this.backCard2.active) {
					this.backCard2.setInteractive();
				}
				if (!first2) this.card2.setInteractive();

				this.chatChannel.postMessage(JSON.stringify({ action: 'card-zoom-close' }));
			})
			.setDepth(2);
	}

	cardZoom2(zoomKey) {
		if (this.backCard.active) this.backCard.disableInteractive();
		if (this.backCard2.active) this.backCard2.disableInteractive();
		if (!first) this.card.disableInteractive();
		this.card2.disableInteractive();
		this.rules.disableInteractive();
		this.back.disableInteractive();
		this.endgameBtn.disableInteractive();
		this.fireworkBtn.disableInteractive();

		this.timerBox2 = this.add
			.image(this.cameras.main.width / 2 - 650, this.cameras.main.height / 2 + 400, 'clock')
			.setDepth(1);

		timer.x = this.cameras.main.width / 2 - 650;
		timer.y = this.cameras.main.height / 2 + 389;

		this.blackBg = this.add
			.image(0, 0, 'black_bg')
			.setOrigin(0, 0)
			.setScale(2)
			.setAlpha(0.8)
			.setDepth(0.9);

		this.zoomCard = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 15, zoomKey + language)
			.setDepth(2)
			.setScale(1);

		this.zoomedFireworkBtn = this.add
			.image(this.cameras.main.width / 2 + 630, 50, 'appreciate-small_btn' + language)
			.setScale(1.25)
			.setDepth(2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				this.startFireworks();
				this.chatChannel.postMessage(JSON.stringify({ action: 'fireworks' }));
			});

		this.closeBtn = this.add
			.image(110, 50, 'close_btn' + language)
			.setScale(1.2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				timer.x = this.cameras.main.width / 2 - 5;
				timer.y = 37;

				this.zoomedFireworkBtn.destroy();
				this.blackBg.destroy();
				this.zoomCard.destroy();
				this.closeBtn.destroy();
				this.timerBox2.destroy();
				this.card2.setInteractive();
				this.rules.setInteractive();
				this.back.setInteractive();
				this.endgameBtn.setInteractive();
				this.fireworkBtn.setInteractive();

				if (!first) {
					this.card.setInteractive();
				}
				if (this.backCard.active) {
					this.backCard.setInteractive();
				}

				this.chatChannel.postMessage(JSON.stringify({ action: 'card-zoom-close' }));
			})
			.setDepth(2);
	}

	startFireworks() {
		let self = this;
		const getRandomNumber = (min, max) => Math.random() * (max - min) + min;

		this.anims.create({
			key: 'anim-firework-blue',
			frames: this.anims.generateFrameNames('firework-blue'),
			frameRate: 30,
			repeat: 0,
		});

		this.anims.create({
			key: 'anim-firework-red',
			frames: this.anims.generateFrameNames('firework-red'),
			frameRate: 30,
			repeat: 0,
		});

		(function loop(times) {
			setTimeout(
				() => {
					const firework = self.add
						.sprite(getRandomNumber(150, 1400), getRandomNumber(150, 909), 'firework-blue')
						.setDepth(2)
						.play('anim-firework-blue');
					firework.on('animationcomplete', () => {
						firework.destroy();
					});

					if (--times) loop(times); //  decrement i and call myLoop again if i > 0
				},
				getRandomNumber(500, 1000),
			);
		})(10);

		(function loop(times) {
			setTimeout(
				() => {
					const firework = self.add
						.sprite(getRandomNumber(150, 1400), getRandomNumber(150, 909), 'firework-red')
						.setDepth(2)
						.play('anim-firework-red');
					firework.on('animationcomplete', () => {
						firework.destroy();
					});
					if (--times) loop(times); //  decrement i and call myLoop again if i > 0
				},
				getRandomNumber(500, 1000),
			);
		})(10);
	}

	shuffleDecks(deck1, deck2) {
		let shuffledIndices = Array.from(Array(deck1.length).keys());

		for (let i = shuffledIndices.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledIndices[i], shuffledIndices[j]] = [shuffledIndices[j], shuffledIndices[i]];
		}

		let shuffledDeck1 = [];
		let shuffledDeck2 = [];
		for (let i = 0; i < shuffledIndices.length; i++) {
			shuffledDeck1.push(deck1[shuffledIndices[i]]);
			shuffledDeck2.push(deck2[shuffledIndices[i]]);
		}

		return [shuffledDeck1, shuffledDeck2];
	}

	update(data) {
		if (time_timer + 1000 <= this.scene.scene.time.now && started && !end) {
			time_left -= 1;
			let elapsedTime = time_left;
			let minutes = Math.floor(elapsedTime / 60);
			let seconds = Math.floor(elapsedTime - minutes * 60);
			time_timer = this.scene.scene.time.now;
			switch (duration) {
				case 300:
					if (seconds == 0 && minutes == 2) {
						this.twoMinPopup.setVisible(true).setDepth(2.2);
						setTimeout(() => {
							this.twoMinPopup.destroy();
						}, 5000);
					}
					break;
				default:
					if (seconds == 0 && minutes == 2) {
						this.twoMinPopup.setVisible(true).setDepth(2.2);
						setTimeout(() => {
							this.twoMinPopup.destroy();
						}, 5000);
					}
					if (seconds == 0 && minutes == 5) {
						this.fiveMinPopup.setVisible(true).setDepth(2.2);
						setTimeout(() => {
							this.fiveMinPopup.destroy();
						}, 5000);
					}
					break;
			}
			if (seconds == 0 && minutes == 0) {
				end = true;
				if (this.backCard.active) this.backCard.disableInteractive();
				// this.back.disableInteractive();
				// this.rules.disableInteractive();
				// this.fireworkBtn.disableInteractive();
				// this.endgameBtn.disableInteractive();
				this.chatChannel.postMessage(JSON.stringify({ action: 'times-up' }));
				var gameOverPop = this.add
					.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'times_up' + language)
					.setDepth(2);
				setTimeout(() => {
					// this.back.setInteractive();
					// this.rules.setInteractive();
					// this.fireworkBtn.setInteractive();
					// this.endgameBtn.setInteractive();
					gameOverPop.destroy();
					// this.scene.start(CST.SCENES.ENDSCREEN, { scene: CST.SCENES.BOARD, data: data.data });
				}, 2500);
			}
			if (seconds < 10) {
				timer.text = minutes + ':0' + seconds;
			} else {
				timer.text = minutes + ':' + seconds;
			}
		}
	}

	resetTimer() {
		timerStarted = false;
		if (timer) {
			timer.destroy();
		}
		time_left = 0;
		duration = 0;
		started = false;
	}

	showFacilitatorPopup() {
		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		const overlay = this.add
			.rectangle(cx, cy, 1500, 929, 0x000000, 0.6)
			.setDepth(100)
			.setInteractive();
		const popup = this.add.image(cx, cy, 'popup-facilitator-tab').setDepth(101);
		const btnClose = this.add
			.image(cx, cy + 185, 'close_btn')
			.setInteractive({ useHandCursor: true })
			.setDepth(102)
			.on('pointerdown', () => {
				overlay.destroy();
				popup.destroy();
				btnClose.destroy();
			});
	}
}

function loadCardsFromDatabase() {
	return new Promise((resolve, reject) => {
		$.ajax({
			type: 'get',
			url: 'website/get-cards-to-json.php',
			success: function (array) {
				resolve(array);
			},
			error: function (error) {
				console.log(error);
				reject(error);
			},
		});
	});
}
